export const siteData = {
  name: "Arron Frasier",
  initials: "AF",
  title: "Senior Software Engineer",
  tagline: "Building reliable software & living intentionally",
  
  resume: "https://drive.google.com/file/d/1UOG3S1yBfHjJUtmAXjwuP8YbOv-NLiNO/view?usp=sharing",
  profilePhoto: "/family-photo.jpeg", // Set to an image URL when you add a photo

  // About section - personal highlights
  about: {
    intro: "I'm a software engineer who enjoys solving complex problems and building applications that make a difference. More importantly, I'm a husband, father, and follower of Christ. My faith shapes how I approach life and work, and I believe great software is built by great people who trust each other, communicate well, and genuinely enjoy working together.",
    values: [
      {
        title: "Faith",
        description: "My relationship with Christ is the foundation of my life. It influences how I lead, serve others, and approach challenges with humility, integrity, and purpose."
      },
      {
        title: "Family",
        description: "Being present for my family is one of my highest priorities. Whether it's celebrating milestones or simply being available when needed, I believe success means little if it comes at the expense of the people who matter most."
      },
      {
        title: "People & Craft",
        description: "I enjoy building software, but I care just as much about the people building it. I strive to be someone who's easy to work with, values collaboration, and helps create environments where teams can do their best work."
      },
      {
        title: "Fitness",
        description: "Outside of technology, you'll usually find me in the gym training CrossFit or preparing for my first HYROX event. Fitness teaches discipline, consistency, and the value of pushing beyond what's comfortable."
      }
    ]
  },

  links: [
    { label: "GitHub",    href: "https://github.com/afrasier02/",          icon: "github"    },
    { label: "LinkedIn",  href: "https://www.linkedin.com/in/arron-frasier-4b679515/",     icon: "linkedin"  },
    { label: "Email",     href: "mailto:afrasier02@gmail.com",     icon: "mail"      },
  ],

  skillsHeadline: "My Toolkit",
  
  skills: [
    "TypeScript", "Python", "React", "JavaScript",
    "C#", "Java", "Go", "SQL",
    "AWS", "Azure", "Terraform",
    "PostgreSQL", "DynamoDB", "Kafka", "RabbitMQ",
    "Docker", "CI/CD", ".NET Core", "Spring",
    "Node.js", "Microservices", "Event-Driven", "REST APIs",
  ],

  projectsHeadline: "Selected initiatives from 10+ years of experience building cloud-native applications, enterprise integrations, financial systems, and distributed platforms.",

  projects: [
    {
      name: "Enterprise Payment & Fraud Platform",
      year: "2022–Present",
      description: "Architected and delivered cloud-native payment and fraud prevention services supporting high-volume financial transactions. Built event-driven workflows using AWS Lambda, DynamoDB, and Step Functions, while implementing CI/CD pipelines, observability, and automated monitoring that improved platform reliability and reduced operational downtime.",
      tags: ["AWS", "Lambda", "DynamoDB", "Step Functions", "TypeScript", "Go"],
      category: "Cloud Architecture"
    },
    {
      name: "Legacy Banking Modernization",
      year: "2019–2022",
      description: "Led the modernization of critical banking applications by transforming monolithic ASP.NET systems into scalable microservices using CQRS and event-driven patterns. Helped drive the organization's transition from waterfall delivery to Agile practices, improving maintainability, deployment speed, and team productivity.",
      tags: ["C#", ".NET", "Microservices", "CQRS", "Azure DevOps", "Scrum"],
      category: "Architecture & Modernization"
    },
    {
      name: "Mainframe-to-Cloud Integration Platform",
      year: "2019–2022",
      description: "Designed and developed enterprise integration services connecting legacy mainframe applications with Oracle Cloud platforms. Built resilient APIs and messaging workflows using .NET Core and RabbitMQ, enabling real-time data exchange and reducing operational processing delays.",
      tags: [".NET Core", "RabbitMQ", "Oracle Cloud", "REST APIs", "C#"],
      category: "Enterprise Integration"
    },
    {
      name: "Digital Banking Experience",
      year: "2020–2021",
      description: "Developed a modern React-based banking platform that replaced legacy vendor interfaces and accelerated delivery of new financial products. Integrated frontend experiences with .NET Core APIs and contributed to large-scale implementations of Fiserv Corillian banking solutions.",
      tags: ["React", ".NET Core", "JavaScript", "Fiserv", "Agile"],
      category: "Full-Stack Development"
    },
    {
      name: "Big Data Analytics Platform",
      year: "2018–2020",
      description: "Built large-scale analytics and reporting solutions leveraging Bloomberg, Google Analytics, and enterprise datasets. Designed data processing pipelines using Hadoop, HBase, Impala, and Solr to transform billions of records into actionable business intelligence and operational insights.",
      tags: ["Hadoop", "HBase", "Impala", "Solr", "ASP.NET"],
      category: "Data Engineering"
    },
    {
      name: "IoT Connectivity & Telemetry Platform",
      year: "2017–2019",
      description: "Engineered a cloud-based machine-to-machine (M2M) platform supporting large-scale wireless device communication and telemetry processing. Built distributed services using Java Spring, RabbitMQ, Cassandra, and AWS to enable real-time ingestion and analysis of IoT data.",
      tags: ["Java", "Spring", "AWS", "RabbitMQ", "Cassandra", "IoT"],
      category: "Distributed Systems"
    }
  ],
};
